import { END_POINT } from "constants/apiConstant";
import { apiGet, apiPost } from "../utils/apiUtils";

const { RUTRONIK_ORDER_EMAIL, RUTRONIK_SEND_ORDER_EMAIL } = END_POINT;

// Fetch the Rutronik order email configured for the company (to pre-fill the draft).
export const getRutronikOrderEmail = async () => {
  return await apiGet(RUTRONIK_ORDER_EMAIL);
};

// Send the Rutronik order email with the generated Excel attached.
export const sendRutronikOrderEmail = async (payload) => {
  return await apiPost(RUTRONIK_SEND_ORDER_EMAIL, payload);
};
